import React from "react";
import styled from "styled-components";
import { Link, useNavigate } from "react-router-dom";
import Text from "../Text";
import Icon from "../Icon";
import { COLOR_SYSTEM } from "components/design/design-system";
import { log, LogLevel } from "utils/LogUtil";

const ItemContainer = styled.div`
  display: flex;
  align-items: center;
`;

const StyledLink = styled(Link)`
  text-decoration: none;
  color: ${COLOR_SYSTEM.get("Gray")?.[600]};
  transition: color 0.2s ease;

  &:hover {
    color: ${COLOR_SYSTEM.get("Gray")?.[900]};
    text-decoration: underline;
  }
`;

const CurrentItem = styled.span`
  color: ${COLOR_SYSTEM.get("Gray")?.[900]};
  font-weight: 500;
`;

const ChevronIcon = styled.div`
  margin: 0 4px;
  color: ${COLOR_SYSTEM.get("Gray")?.[400]};
  display: flex;
  align-items: center;
`;

export interface BreadcrumbItemProps {
  text: string;
  href?: string;
  isLast?: boolean;
  showChevron?: boolean;
}

const BreadcrumbItem: React.FC<BreadcrumbItemProps> = ({
  text,
  href,
  isLast = false,
  showChevron = true,
}) => {
  const navigate = useNavigate();
  
  const handleClick = (e: React.MouseEvent) => {
    // 편집 모드 체크
    const isInEditMode = (window as any).__isInEditMode;
    if (isInEditMode) {
      e.preventDefault(); // 기본 네비게이션 방지
      
      const confirmResult = window.confirm(
        "편집 중인 내용이 있습니다.\n\n정말 이 페이지를 벗어나시겠습니까?"
      );
      
      if (!confirmResult) {
        log(LogLevel.INFO, "[BreadcrumbItem] 사용자가 네비게이션 취소");
        return;
      }
      
      // 사용자가 확인했으면 상태 초기화 후 네비게이션
      log(LogLevel.INFO, "[BreadcrumbItem] 사용자가 네비게이션 확인", { href });
      (window as any).__isInEditMode = false;
      if (href) {
        navigate(href);
      }
    }
  };
  
  return (
    <ItemContainer>
      {href && !isLast ? (
        <StyledLink to={href} onClick={handleClick}>
          <Text textType="Body2" color={COLOR_SYSTEM.get("Gray")?.[600]}>
            {text}
          </Text>
        </StyledLink>
      ) : (
        <CurrentItem>
          <Text textType="Body2Medium" color={COLOR_SYSTEM.get("Gray")?.[900]}>
            {text}
          </Text>
        </CurrentItem>
      )}
      {showChevron && !isLast && (
        <ChevronIcon>
          <Icon name="Chevron Right" size={12} color={COLOR_SYSTEM.get("Gray")?.[400]} />
        </ChevronIcon>
      )}
    </ItemContainer>
  );
};

export default BreadcrumbItem;

